import React from "react";
import Layout from "../components/layout/Layout";
import { Card,Table, Icon, Divider, Col, Row } from "antd";
import G2 from "@antv/g2";
import DataSet from "@antv/g2";
import PieChart from "../components/chart/PieChart";
import RingChart from "../components/chart/RingChart";
import ColumnChart from "../components/chart/ColumnChart";
import BarChart from "../components/chart/BarChart";
import QuestionBox from "../components/form/QuestionBox";
import LegendList from "../components/form/LegendList";
import PercentDrawer from "../components/form/PercentDrawer";

const pie_data =[
	{item: "BOBO-0", count:40},
	{item: "BOBO-1", count:30},
	{item: "BOBO-2", count:20},
	{item: "BOBO-3", count:10},
	{item: "BOBO-4", count:50},
];

const ring_data = [
	{ item: "TANGA-0", count: 40 },
	{ item: "TANGA-1", count: 21 },
	{ item: "TANGA-2", count: 17 },
	{ item: "TANGA-3", count: 13 },
	{ item: "TANGA-4", count: 9 }
];

const column_data = [
	{ year: "INAMO0", sales: 38 },
	{ year: "INAMO1", sales: 52 },
	{ year: "INAMO2", sales: 61 },
	{ year: "INAMO3", sales: 145 },
	{ year: "INAMO4", sales: 48 },
	{ year: "INAMO5", sales: 38 },
	{ year: "INAMO6", sales: 38 },
	{ year: "INAMO7", sales: 38 },
];

const gridStyle = {
	width: "50%",
	// textAlign: 'center',
};

const data = [
	{icon:"up-circle" , text:"Text", value:"Value", percent:Math.floor(Math.random()*40)+"%"},
	{icon:"down-circle" , text:"Text",value:"Value", percent:Math.floor(Math.random()*40)+"%"},
	{icon:"left-circle" , text:"Text",value:"Value", percent:Math.floor(Math.random()*40)+"%"},
	{icon:"right-circle" , text:"Text",value:"Value", percent:Math.floor(Math.random()*40)+"%"},
	{icon:"question-circle" , text:"Text",value:"Value", percent:Math.floor(Math.random()*40)+"%"},
];

const Report = () => {
	return(<Layout>
		<div> 
			<Row gutter={16}>
				<Col span={12}>
					<PieChart data={pie_data} />
				</Col>
				<Col span={12} style={{ paddingTop: 10, width: "50%" }}>
					<Row gutter={16}>
						<LegendList header={"HEADERTEST"} innerStyle={{ alignItems: "center", display: "flex", height: "100%" }}>
							{data.map((Val, i) => (
								<PercentDrawer key={i} icon={Val.icon} text={Val.text} value={Val.value} percent={Val.percent} />
							))}
						</LegendList>
					</Row>
				</Col>
			</Row>
            "BOBO1234"
		</div>
	</Layout>);
};
export default Report;


// WEBPACK FOOTER //
// ./src/containers/Report.js